import ButtonBack from "components/ButtonBack/ButtonBack";
import { __app } from "Utils/App";
import { __chats } from "Utils/Chats/Chats";
import { AppContext } from "Utils/Contexts";
import { AppState } from "Utils/Enums";
import { useContext, useEffect, useState } from "react";
import styles from "./AllConversation.module.scss";


export default function AllConversation() {


  const appStateContext = useContext(AppContext);
  const [hideClass, setHideClass] = useState("");
  const [totalConversations, setTotalConversations] = useState(0);

  useEffect(() => {
    switch (appStateContext) {
      case AppState.home:
        setHideClass(styles["hide-right"]);
        break;
      case AppState.chat:
        setHideClass(styles["hide-left"]);
        break;
      default:
        setHideClass("");
        break;
    }

    __chats.onTotalConversations((data) => {
      setTotalConversations(data.totalConversations);
    });
  }, [appStateContext, hideClass]);

  return (
    <div className={`${styles.container} ${hideClass} ${__app.getClassHeightHeader(AppState.allConversations)}`}>
      <div className={styles["container-content"]}>
        <div className={styles["container-btn-back"]}>
          <ButtonBack backState={AppState.home}></ButtonBack>
        </div>
        <div className={styles["container-title"]}>
          Your Conversations
          <br />
          <div className={styles["text-small"]}>Total {totalConversations}</div>
        </div>
      </div>
    </div>

  )
}
